import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_CLIENT} from '../../constants';

export default {
  id: 'SUPP_CLIENT',
  title: 'Wie kann ich einen Kund löschen?',
  description: '',
  categories: [CONTENT_CATEGORY_CLIENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Es steht Ihnen frei, eine Firma zu löschen, wenn Sie Ihre Dokumente nicht mehr mit dieser Firma teilen möchten. Führen Sie einfach die folgenden Schritte auf Ihrer Plattform aus.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Wechseln Sie zur Registerkarte "Kunden".'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_SUPP_CLIENT/DE_SUPP_CLIENT_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Klicken Sie rechts auf die 3 Punkte vor Ihrem Kund.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_SUPP_CLIENT/DE_SUPP_CLIENT_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Durch Klicken auf die 3 Punkte haben Sie die Möglichkeit, die Firma zu löschen.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_SUPP_CLIENT/DE_SUPP_CLIENT_3.png`
  }]
};
